import Vue from 'vue';
import Vuex from 'vuex';
import videos from './modules/videos/index';
import search from './modules/search/index';

Vue.use(Vuex);
const store = new Vuex.Store({
  modules: {
    videos,
    search,
  },
  state: {},
  actions: {},
  mutations: {},
  getters: {},
});
export default store;
